module.exports = __webpack_public_path__ + "static/img/4.1836a28.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/global_assets/images/carriers/4.png
// module id = InFN
// module chunks = 150